// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"ac1b4cfc","511":"3ed2a717"}[chunkId] + ".chunk.js";
};